import {AfterViewInit, Component, EventEmitter, Inject, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Location} from '@angular/common';
import {ConfService} from './conf.service';
import {environment} from '../environments/environment';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatIconRegistry, MatSnackBar} from '@angular/material';
import {DomSanitizer} from '@angular/platform-browser';
import {RoutingStateService} from './core/routingState/routingState.service';
import {Loggedin} from './authFilter/platformCentralAuth';
import {v4 as uuid} from 'uuid';
import {HttpClient} from '@angular/common/http';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ConnecttocrudService} from './connecttocrud.service';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {Observable, Subject} from 'rxjs';
import {Orientation} from 'ngx-guided-tour';
import {ListenerService} from './listener.service';
import {WebsocketService} from './websocket.service';
import {JwtParserService} from './jwt-parser.service';
import {AccountInfoService} from './user/account-info.service';
import {AuthService} from './user/auth.service';
import {AdminEnvironmentHandlerService} from './admin-environment-handler.service';
import {PartnerSettingsService} from './partnerSettings/partner-settings.service';

declare let $;
declare global {
    interface Window {
        kommunicate?: any;
    }
}

interface GuidedTour {
    /** Identifier for tour */
    tourId: string;
    /** Use orb to start tour */
    useOrb?: boolean;
    /** Steps for the tour */
    steps: TourStep[];
    /** Function will be called when tour is skipped */
    skipCallback?: (stepSkippedOn: number) => void;
    /** Function will be called when tour is completed */
    completeCallback?: () => void;
    /** Minimum size of screen in pixels before the tour is run, if the tour is resized below this value the user will be told to resize */
    minimumScreenSize?: number;
    /** Dialog shown if the window width is smaller than the defined minimum screen size. */
    resizeDialog?: {
        /** Resize dialog title text */
        title?: string;
        /** Resize dialog text */
        content: string;
    };
}

interface TourStep {
    /** Selector for element that will be highlighted */
    selector?: string;
    /** Tour title text */
    title?: string;
    /** Tour step text */
    content: string;
    /** Where the tour step will appear next to the selected element */
    orientation?: Orientation | OrientationConfiguration[];
    /** Action that happens when the step is opened */
    action?: () => void;
    /** Action that happens when the step is closed */
    closeAction?: () => void;
    /** Skips this step, this is so you do not have create multiple tour configurations based on user settings/permissions */
    skipStep?: boolean;
    /** Adds some padding for things like sticky headers when scrolling to an element */
    scrollAdjustment?: number;
    /** Adds default padding around tour highlighting. Does not need to be true for highlightPadding to work */
    useHighlightPadding?: boolean;
    /** Adds padding around tour highlighting in pixels, this overwrites the default for this step. Is not dependent on useHighlightPadding being true */
    highlightPadding?: number;
}

interface OrientationConfiguration {
    /** Where the tour step will appear next to the selected element */
    orientationDirection: Orientation,
    /** When this orientation configuration starts in pixels */
    maximumSize?: number
}

declare var ga: Function;

@Component({
        selector: 'app-component',
        templateUrl: './app.component.html',
        styleUrls: ['./app.component.css']
    }
)
export class AppComponent implements OnInit, AfterViewInit {

    public modalRef: BsModalRef;

    @ViewChild('childModal', {static: false}) childModal: ModalDirective;

    loading = true;
    domainPartner = 'services';
    partnerLogo = 'assets/logo/logo.svg';
    brandImage = '';
    Headercheck: any;
    SidePanelCheck: boolean;
    HeaderRibbon: boolean;
    route: any;
    ribbon: string;
    isWorkflow: boolean;
    isExecuteEmailTemplate: boolean;
    isConsole: boolean;
    isSignUp = false;
    isConnectors: boolean;
    items: any;
    homeCheck = false;
    SideMenuNavigationUrl: string;

    subMenuPanelExpanded = false;
    leftMenuPanelExpanded = 'col-md-1 col-lg-1 sideBarExpanded';
    userName: string;
    currentPageTitle = '';
    isCampaignManager = false;
    sessionID: any;

    reservationCollectionPayload = {
        IPAddress: '',
        partner: '',
        browserDetails: {
            name: '',
            version: ''
        },
        os: {
            name: '',
            version: ''
        },
        sessionId: ''
    };

    idleState = 'Click on stay with apiplatform.io to continue building your APIs.';
    timedOut = false;
    lastPing?: Date = null;
    title = 'angular-idle-timeout';
    private userLoggedIn = new Subject<boolean>();
    loggedIn: EventEmitter<any> = new EventEmitter();

    currentSession: any;

    idOfCurrentSession: number;
    actionsOfCurrentSession = [];

    auditLogPermissions = {
        isAuditForAuth: true,
        login_submit_next_clicked: true,
        login_submit_next_success: true,
        login_submit_next_failed: true,
        signup_submit_next_clicked: true,
        signup_submit_next_success: true,
        signup_submit_next_failed: true,
        signup_submit_verifyotp_clicked: true,
        signup_submit_resendotp_clicked: true,
        signup_submit_resendotp_success: true,
        signup_submit_resendotp_failed: true,
        signup_onboarding_checkpartnershortcodeexistence_success: true,
        signup_onboarding_checkpartnershortcodeexistence_failed: true,
        signup_onboarding_resendverificationlink_success: true,
        signup_onboarding_resendverificationlink_failed: false,
        signup_onboarding_notifyerrortoadmins_success: true,
        signup_onboarding_notifyerrortoadmins_failed: true,
        signup_onboarding_dnsvalidation_success: true,
        signup_onboarding_dnsvalidation_failed: true,
        signup_onboarding_environmentrecreation_success: true,
        signup_onboarding_environmentrecreation_failed: true,
        signup_onboarding_patchadminpartnersettings_failed: true,
        signup_onboarding_patchadminpartnersettings_success: true,
        signup_onboarding_environmentcreation_success: true,
        signup_onboarding_environmentcreation_failed: true,
        signup_onboarding_getpartnerkey_failed: true,
        signup_onboarding_getpartnerkey_success: true,
        signup_onboarding_createconsumerinapigateway_failed: true,
        signup_onboarding_createconsumerinapigateway_success: true,
        signup_onboarding_createdefaultconsumerinapigateway_failed: true,
        signup_onboarding_createdefaultconsumerinapigateway_success: true,
        signup_onboarding_configureapikeyauthentication_failed: true,
        signup_onboarding_configureapikeyauthentication_success: true,
        signup_onboarding_partnercreation_success: true,
        signup_onboarding_partnercreation_failed: true,
        signup_onboarding_usercreation_success: true,
        signup_onboarding_usercreation_failed: true,
        signup_onboarding_rolecreation_success: true,
        signup_onboarding_rolecreation_failed: true,
        signup_onboarding_updateonboardingtoken_success: true,
        signup_onboarding_updateonboardingtoken_failed: true,
        signup_onboarding_settingscreation_success: true,
        signup_onboarding_settingscreation_failed: true,
        signup_onboarding_getapikey_failed: true,
        signup_onboarding_getapikey_success: true,
        signup_onboarding_executeemail_failed: true,
        signup_onboarding_executeemail_success: true,
        logout_clicked: true,
        logout_success: true
    };
    headinglabel: string;
    isDataInitialised = false;
    idleWatchDialog: MatDialogRef<IdleWatchComponent>;
    defaultIdleTimeoutConfig = {
        name: 'Idle Timeout',
        is_enabled: true,
        idle_timeout: 1200,
        ping_interval: 15,
        timer_to_logout: 15
    };
    idleTimeOutConfig: any;
    invokeCount = 0;

    partners: any;

    passphrase = environment.cipheringPhrase;
    iterationCount = 1000;
    keySize = 128;

    availableEnvironmentsToSwitch = [];

    isUserLoggedIn = false;

    isServerStatusPanelOpened = false;
    isNotificationPanelOpened = false;
    isAlertsPanelOpened = false;
    isPartnerInfoPanelOpened = false;
    // Variables For permissions

    parsedJWT: any;
    permissions = [];
    permissionIDs = [];
    permissionsReceived: boolean;
    platformPermissionFound = false;


    //for bulk script
    applicationPermissionConfig: any;

    permissionRetryCount = 0;
    permissionGroupRetryCount = 0;
    permissionIDArray = [];
    permissionGroupId: any;
    partner = localStorage.getItem('partner');


    constructor(public idle: Idle, private keepalive: Keepalive, private deviceService: DeviceDetectorService, private httpClient: HttpClient,
                iconRegistry: MatIconRegistry, private routingState: RoutingStateService, sanitizer: DomSanitizer, private location: Location,
                private router: Router, private Urlroute: ActivatedRoute, private confPost: ConfService, private _service: ConnecttocrudService,
                public auth: Loggedin, private snackBar: MatSnackBar, private dialog: MatDialog, private listenerInstance: ListenerService,
                public websocketService: WebsocketService,
                public accountInfoService: AccountInfoService,
                public authService: AuthService,
                private partnerSettingsService: PartnerSettingsService
    ) {

        this.routingState.loadRouting();
        this.addSvgIcons(iconRegistry, sanitizer);
        this.router.events.subscribe(async event => {
            this.getLeftPanel();
            if (event instanceof NavigationEnd) {
                if (environment.googleAnalytics) {
                    ga('set', 'page', event.urlAfterRedirects);
                    ga('send', 'pageview');
                }
            }
        });

        window.addEventListener('storage', (event) => {
            if (event.storageArea === localStorage) {
                if (!localStorage.getItem('Auth')) {
                    if (localStorage.getItem('setLogOutFromAllTabs') && localStorage.getItem('setLogOutFromAllTabs') === 'true') {
                        localStorage.removeItem('setLogOutFromAllTabs');
                        window.location.href = '/';
                    }
                } else {
                    localStorage.setItem('setLogOutFromAllTabs', 'true');
                }
            }
        }, false);

        this.loggedIn.subscribe(
            async (status) => {
                if (status === true) {
                    this.isUserLoggedIn = true;
                    Promise.resolve(this.getIdleTimeoutConfig()).then(resp => {
                        if (this.idleTimeOutConfig && this.idleTimeOutConfig !== null && this.idleTimeOutConfig !== undefined && this.idleTimeOutConfig.is_enabled === true) {
                            // this.idle.watch();
                            this.invokeCount += 1;
                            this.startLookingForIdleTimeout();
                            this.timedOut = false;
                        }
                    });
                } else {
                    this.idle.stop();
                }
            }
        );

        if (localStorage.getItem('partner') !== undefined && localStorage.getItem('partner') !== null) {
            Promise.resolve(this.getIdleTimeoutConfig()).then(resp => {
                if (this.idleTimeOutConfig && this.idleTimeOutConfig !== null && this.idleTimeOutConfig !== undefined && this.idleTimeOutConfig.is_enabled === true) {
                    // idle.watch();
                    this.invokeCount += 1;
                    this.startLookingForIdleTimeout();
                    this.timedOut = false;
                }
            });
        }

        this.items = [];
        //  this.getLeftPanel();

        this.Urlroute.queryParams
            .subscribe(params => {
                if (params.entity) {
                    if (this.location.path() !== '') {
                        this.route = this.location.path();
                        if (this.route.includes('/entity/edit')) {
                            this.headinglabel = params.entity;
                        } else {
                            this.headinglabel = params.entity;
                        }
                    }
                } else if (params.executor_name) {
                    this.headinglabel = params.executor_name;
                    if (params.executor_version) {
                        this.headinglabel += ' (' + params.executor_version + ')';
                    }
                }

                if (params.name && params.version) {
                    this.route = this.location.path();
                    if (this.route.includes('/apijoins')) {
                        this.headinglabel = params.name + ' (' + params.version + ')';
                    }
                }
            });
    }

    closeHeaderRibbonNav(event) {
        if (event.target !== document.getElementById('ss-logo') && event.target !== document.getElementById('not-logo')
            && event.target !== document.getElementById('partnerinfo-logo') && event.target !== document.getElementById('alerts-logo')) {
            this.isNotificationPanelOpened = false;
            this.isServerStatusPanelOpened = false;
            this.isPartnerInfoPanelOpened = false;
            this.isAlertsPanelOpened = false;
        }
    }

    serverStatusPanelStateChanged() {
        this.isServerStatusPanelOpened = true;
    }

    notificationPanedStateChanged() {
        this.isNotificationPanelOpened = true;
    }
    partnerInfoPanelStateChanged() {
        this.isPartnerInfoPanelOpened = true;
    }
    alertsPanelStateChanged() {
        this.isAlertsPanelOpened = true;
    }

    returnAuth() {
        return localStorage.getItem('Auth');
    }

    startLookingForIdleTimeout() {
        if (this.idleTimeOutConfig && this.idleTimeOutConfig !== null && this.idleTimeOutConfig !== undefined && this.idleTimeOutConfig.is_enabled === true) {
            // sets an idle timeout of 15 minutes, for testing purposes.
            this.idle.stop();
            let timeoutValue: number | false;
            if (this.idleTimeOutConfig.timer_to_logout === false) {
                timeoutValue = false;
            } else {
                const parsedTimeout = Number(this.idleTimeOutConfig.timer_to_logout);
                timeoutValue = parsedTimeout > 0 ? parsedTimeout : false;
            }
            this.idle.setIdle(this.idleTimeOutConfig.idle_timeout);
            // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
            this.idle.setTimeout(timeoutValue);
            // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
            this.idle.clearInterrupts();
            this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
            // sets the ping interval to 15 seconds
            this.keepalive.interval(this.idleTimeOutConfig.ping_interval);


            this.idle.watch();

            this.idle.onIdleEnd.subscribe(() => {
                // this.idleState = 'No longer idle.'
                this.idleState = 'Click on stay with apiplatform.io to continue building your APIs.';
                this.reset();
            });

            this.idle.onTimeout.subscribe(() => {
                // this.childModal.hide();
                if (this.idleWatchDialog !== undefined) {
                    this.idleWatchDialog.close();
                }
                this.idleState = 'Timed out!';
                this.timedOut = true;
                this.logoutOnIdle();
            });

            this.idle.onIdleStart.subscribe(() => {
                this.idleState = 'You\'ve gone idle!';
                if (this.childModal !== undefined) {
                    // this.childModal.show();
                    if (this.idleWatchDialog !== undefined) {
                        this.idleWatchDialog.close();
                    }
                    this.idleWatchDialog = this.dialog.open(IdleWatchComponent, {
                        maxWidth: '70vw',
                        maxHeight: '60vh',
                        position: {
                            top: '5px',
                        },
                        data: {
                            idleTimeout: this.idleTimeOutConfig.idle_timeout
                        }
                    });
                    // this.idle.stop();
                }
            });

            this.idle.onTimeoutWarning.subscribe((countdown) => {
                this.idleState = 'You will time out in ' + countdown + ' seconds!';
            });

            this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
        }
    }

    setUserLoggedIn(userLoggedIn: boolean) {
        this.userLoggedIn.next(userLoggedIn);
    }

    getUserLoggedIn(): Observable<boolean> {
        return this.userLoggedIn.asObservable();
    }

    patchEntityData(partner, account, version, entity, id, payload) {
        return new Promise((resolve, reject) => {
            this.confPost.patchEntityData(partner, account, version, entity, id, payload).subscribe(response1 => {
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });
    }

    getIdleTimeoutConfig() {
        return new Promise((resolve, reject) => {
            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(response => {
                if (response && response['body'] && response['body'] !== null && response['body'] !== undefined) {
                    const environments = response['body'][0]['environments'];
                    environments.forEach((env) => {
                        if (env && env !== null && env !== undefined) {
                            if (env['name'] === localStorage.getItem('partner')) {
                                const services = env['services'];
                                if ((services.filter(element => element.name === 'Time')).length === 0) {
                                    this.idleTimeOutConfig = this.defaultIdleTimeoutConfig;
                                    let index = 0;
                                    for (const env1 of response['body'][0]['environments']) {
                                        if (env1 && env1 !== null && env1 !== undefined) {
                                            this.confPost.getSettingsV2CRUD(env1['name'], env1['name'], false).subscribe(response1 => {
                                                if (response1 && response1['body'] && response1.status === 200) {
                                                    for (const env2 of response1['body'][0]['environments']) {
                                                        if (env2 && env2 !== null && env2 !== undefined) {
                                                            if ((env2['services'].filter(element => element.name === 'Time')).length === 0) {
                                                                env2['services'].push({
                                                                    name: 'Time',
                                                                    type: 'time',
                                                                    configurations: [this.idleTimeOutConfig]
                                                                });
                                                            }
                                                        }
                                                    }
                                                    index += 1;
                                                    this.patchEntityData('services', 'services', 'v2', 'settings', response1['body'][0]['id'], response1['body'][0]).then(resp => {
                                                        if (index === response['body'][0]['environments'].length) {
                                                            resolve('success');
                                                            localStorage.setItem('idleTimeoutInvokeCount', '2');
                                                        }
                                                    }, error => {
                                                        resolve('failed');
                                                    });
                                                }
                                            }, error => {
                                                resolve('failed');
                                            });
                                        } else {
                                            resolve('failed');
                                        }
                                    }
                                } else {
                                    const timeService = services.filter(element => element.name === 'Time');
                                    for (const config of timeService[0]['configurations']) {
                                        if (config && config !== null && config !== undefined) {
                                            if (config['name'] === 'Idle Timeout') {
                                                this.idleTimeOutConfig = config;
                                                localStorage.setItem('idleTimeoutInvokeCount', '2');
                                                resolve('success');
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            resolve('failed');
                        }
                    });
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
            });
        });
    }

    ngAfterViewInit() {
        this.idle.onIdleStart.subscribe(() => {
            this.idleState = 'You\'ve gone idle!';
            // this.childModal.show();
            if (this.idleWatchDialog !== undefined) {
                this.idleWatchDialog.close();
            }
            this.idleWatchDialog = this.dialog.open(IdleWatchComponent, {
                maxWidth: '50vw',
                maxHeight: '60vh',
                position: {
                    top: '5px',
                },
                data: {
                    idleTimeout: this.idleTimeOutConfig.idle_timeout
                }
            });
        });
    }

    returnErrorMessage(error) {
        let errorMessage = '';
        if (error.error) {
            if (error.error['message']) {
                errorMessage = error.error.message;
            } else {
                errorMessage = error.error;
            }
        } else {
            errorMessage = 'Error while performing required action. Please try again sometime.';
        }
        return errorMessage;
    }

    // this function has to be removed completely
    generatePayloadForAudit(logType, logLevel, slug, label, featureArea, resource, action, result,
                            payload, responseStatusCode, response, logMessage, errorMessage = '') {
        return new Promise((resolve, reject) => {
            resolve();
        });
    }


    reset() {
        this.idle.watch();
        // this.idle.setIdle(10);
        // this.idle.setTimeout(15);
        // this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        // this.keepalive.interval(30);
        this.timedOut = false;
    }

    hideChildModal(): void {
        this.childModal.hide();
    }

    stay() {
        this.childModal.hide();
        this.reset();
    }

    logoutOnIdle() {
        // this.childModal.hide();
        if (this.idleWatchDialog !== undefined) {
            this.idleWatchDialog.close();
        }
        this.authService.logout();
    }

    onActivate(e, outlet) {
        outlet.scrollTop = 0;
    }

    async getLogo() {
        await this.confPost.getAppConfigs(localStorage.getItem('domainPartner')).toPromise().then((response: any) => {
            localStorage.setItem('logo', response['logo'] ? response['logo'] : this.partnerLogo);
            localStorage.setItem('brandImage', response['brand_image'] ? response['brand_image'] : this.brandImage);
        }, error => {
            localStorage.setItem('logo', this.partnerLogo);
            localStorage.setItem('brandImage', this.brandImage);
        });
    }

    goBack() {
        this.location.back();
    }

    async domainCheck() {

        if (environment.isOnPremise === true) {
            this.domainPartner = 'services';
        } else {
            let partnerCheck;
            const URL = window.location.href;
            // const URL = 'https://console.apiplatform.io/auth/login';
            if (!URL.includes('localhost')) {
                if (URL.includes('//')) {
                    const temp = URL.split('//');
                    partnerCheck = temp[1].split('.');
                } else {
                    partnerCheck = URL.split('.');
                }
                if (partnerCheck.length > 2) {
                    if (partnerCheck[0] !== 'www') {
                        if (partnerCheck[0] !== 'latest' && partnerCheck[0] !== 'console' ) {
                            this.domainPartner = partnerCheck[0];
                        } else {
                            this.domainPartner = partnerCheck[1];
                        }
                    } else {
                        if (partnerCheck[1] !== 'latest' && partnerCheck[1] !== 'console') {
                            this.domainPartner = partnerCheck[1];
                        } else {
                            this.domainPartner = partnerCheck[2];
                        }
                    }
                } else {
                    this.domainPartner = 'services';
                }
                for (const partner of environment.domainPartners) {
                    if (partner === this.domainPartner) {
                        this.domainPartner = 'services';
                        break;
                    }
                }
            } else {
                if (environment.domainPartner) {
                    this.domainPartner = environment.domainPartner;
                }
            }
        }

        localStorage.setItem('domainPartner', this.domainPartner);
        await this.getLogo();
    }

    setKommunicateChatbot() {
        const that = this;
        const chatContext = {
            auth: false
        };
        if (this.accountInfoService.isLoggedIn) {
            chatContext.auth = true;
            chatContext['email'] = this.accountInfoService.email;
            chatContext['env'] = this.accountInfoService.partner;
            chatContext['pkey'] = this.accountInfoService.partnerKey;
        }
        (function(d, m) {
            const kommunicateSettings = {
                appId: environment.kommunicateAppId,
                popupWidget: true,
                automaticChatOpenOnNavigation: true,
                restartConversationByUser : true,
                onInit : function () {
                    const defaultSettings = {
                        customWelcomeEvent: 'custom-event',
                    };
                    m.updateChatContext(chatContext);
                    m.updateSettings(defaultSettings);
                }
            };
            const s = document.createElement('script');
            s.id = 'kommunicate-chat';
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.kommunicate.io/v2/kommunicate.app';
            const h = document.getElementsByTagName('head')[0];
            h.appendChild(s);
            window.kommunicate = m; m._globals = kommunicateSettings;
        })(document, window.kommunicate || {});
    }

    async ngOnInit() {

        if (window.self !== window.top) {
            // If the page is loaded in an iframe, don't allow anything in the Angular application
            document.addEventListener('DOMContentLoaded', function() {
                document.getElementsByTagName('body')[0].innerHTML = '';
            });
        } else {
            Promise.resolve(this.authService.initAuth().then(async response => {
                if (!response) {
                    await this.domainCheck();
                    this.setKommunicateChatbot();
                    this.loading = false;
                } else {
                    this.partnerSettingsService.initPartnerSettings();
                    this.setKommunicateChatbot();
                    this.loading = false;
                }
            }, error => {
                this.snackBar.open(error, 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                setTimeout(() => {
                    window.location.href = '/auth/login';
                }, 2000);
            }));
            this.partnerLogo = localStorage.getItem('logo');
            this.brandImage = localStorage.getItem('brandImage');
            this.subMenuPanelExpanded = false;
        }


    }

    timeConverter(ts) {
        let str = '';
        const date_ob = new Date(ts);
        const year = date_ob.getFullYear();
        const month = ('0' + (date_ob.getMonth() + 1)).slice(-2);
        const date = ('0' + date_ob.getDate()).slice(-2);
        const hours = ('0' + date_ob.getHours()).slice(-2);
        const minutes = ('0' + date_ob.getMinutes()).slice(-2);
        const seconds = ('0' + date_ob.getSeconds()).slice(-2);
        str = str + date + '/' + month + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds;
        return str;
    }

    getPartner() {
        if (localStorage.getItem('partner')) {
            return localStorage.getItem('partner');
        }
    }

    getLeftPanel() {
        this.router.events.subscribe((val) => {
            this.Headercheck = true;
            this.SidePanelCheck = true;
            this.SideMenuNavigationUrl = '/api';
            this.HeaderRibbon = true;
            this.homeCheck = true;

            if (this.location.path() !== '') {
                this.route = this.location.path();
                if (this.route.includes('/controlplane')) {
                    this.ribbon = 'Smart Control Plane';
                } else if (this.route.includes('/billing')) {
                    this.ribbon = 'Billing';
                } else if (this.route.includes('/api-gateway')) {
                    this.ribbon = 'API Gateway';
                } else if (this.route.includes('/api-management')) {
                    this.ribbon = 'Default Gateway Settings';
                } else if (this.route.includes('/signup')) {
                    this.subMenuPanelExpanded = false;
                    this.ribbon = 'Create Your Account';
                    this.isSignUp = true;
                    this.homeCheck = false;
                } else if (this.route.includes('/joinsrequest')) {
                    this.subMenuPanelExpanded = false;
                    this.ribbon = 'API Joins Update/Delete Request';
                    this.homeCheck = false;
                    this.isSignUp = true;
                } else if (this.route.includes('/verifyuser')) {
                    this.subMenuPanelExpanded = false;
                    this.ribbon = 'Create Your Account';
                    this.isSignUp = true;
                } else if (this.route.includes('/authenticator')) {
                    this.subMenuPanelExpanded = false;
                    this.ribbon = 'Authenticator';
                    this.isSignUp = true;
                } else if (this.route.includes('/resetpassword')) {
                    this.ribbon = 'Reset Password';
                } else if (this.route.includes('/dataaccessapi')) {
                    this.ribbon = 'Create Data Access API';
                } else if (this.route.includes('/my-account')) {
                    this.ribbon = 'Manage Accounts';
                } else if (this.route.includes('/customoperation')) {
                    this.ribbon = 'Query Results Viewer';
                } else if (this.route.includes('/querybuilder')) {
                    this.ribbon = 'Query Builder';
                } else if (this.route.includes('/unified-query-builder')) {
                    this.ribbon = 'API Query Builder';
                } else if (this.route.includes('/apimanagement')) {
                    this.ribbon = 'API Gateway Management';
                } else if (this.route.includes('/common-data-api')) {
                    this.ribbon = 'Marketplace - Common Data APIs';
                } else if (this.route.includes('/Privacy-Policy')) {
                    this.ribbon = 'Privacy Policy';
                } else if (this.route.includes('/devex')) {
                    this.SideMenuNavigationUrl = '/devex';
                    this.ribbon = 'Developer Experience';
                } else if (this.route.includes('/gateway')) {
                    this.homeCheck = true;
                    // this.SideMenuNavigationUrl = '/devex';
                    this.ribbon = 'API Gateway Settings';
                } else if (this.route.includes('/swifter')) {
                    // this.SideMenuNavigationUrl = '/swifter';
                    this.ribbon = 'API Launcher';
                } else if (this.route.includes('/businesslogic')) {
                    this.ribbon = 'Business Logic Builder';
                } else if (this.route.includes('/digital-transformer')) {
                    // this.SideMenuNavigationUrl = '/digital-transformer';
                    this.ribbon = 'Database To API';
                } else if (this.route.includes('/application')) {
                    this.ribbon = 'Create from Open API';
                } else if (this.route.includes('/scheduler')) {
                    this.ribbon = 'API Scheduler';
                } else if (this.route.includes('/trigger')) {
                    this.ribbon = 'API Triggers';
                } else if (this.route.includes('/collection')) {
                    this.ribbon = 'API Collections';
                } else if (this.route.includes('/cognitive-search')) {
                    this.ribbon = 'GenAI - Cognitive Search';
                } else if (this.route.includes('/data-analytics')) {
                    this.ribbon = 'GenAI - Data Analytics';
                } else if (this.route.includes('/workflow')) {
                    this.ribbon = 'Workflow Builder';
                    this.isWorkflow = true;
                } else if (this.route === '/console') {
                    this.ribbon = 'Platform Console';
                    this.isConsole = true;
                } else if (this.route.includes('/connectors')) {
                    this.ribbon = 'API Connectors';
                    this.isConnectors = true;
                } else if (this.route.includes('/api-register')) {
                    this.ribbon = 'API Register';
                } else if (this.route.includes('/jsontoapi')) {
                    this.ribbon = 'JSON to API';
                } else if (this.route.includes('/apitoapi')) {
                    this.ribbon = 'API to API';
                } else if (this.route.includes('/executeemailtemplate')) {
                    this.ribbon = 'Schedule and Execute Email';
                    this.isExecuteEmailTemplate = true;
                } else if (this.route.includes('/emailtemplatebuilder')) {
                    this.ribbon = 'Email Template Builder';
                    this.isExecuteEmailTemplate = true;
                } else if (this.route.includes('/email-templates')) {
                    this.ribbon = 'Manage your email templates';
                    this.isExecuteEmailTemplate = true;
                } else if (this.route.includes('apiql')) {
                    this.ribbon = 'APIQL Engine';
                } else if (this.route.includes('dataql')) {
                    this.ribbon = 'DATAQL Engine';
                } else if (this.route.includes('/api-testsuite')) {
                    this.ribbon = 'Test-Suite for API : ' + this.headinglabel;
                } else if (this.route.includes('/test-results')) {
                    this.ribbon = 'Test Suite Results';
                } else if (this.route.includes('/api')) {
                    this.ribbon = 'Manage Data for API : ' + this.headinglabel;
                } else if (this.route.includes('/entity/edit')) {
                    this.ribbon = 'Manage Definition for API : ' + this.headinglabel;
                } else if (this.route.includes('/filestorage')) {
                    this.ribbon = 'Manage Files';
                } else if (this.route.includes('/alerts')) {
                    this.ribbon = 'Alerts';
                } else if (this.route.includes('/campaignmanager')) {
                    this.isCampaignManager = true;
                } else if (this.route.includes('/querybuilderbase')) {
                    this.ribbon = 'Query Builder';
                } else if (this.route.includes('/monitor')) {
                    this.ribbon = 'API Monitor';
                } else if (this.route.includes('/dashboard-metrics')) {
                    this.ribbon = 'Monitoring';
                } else if (this.route.includes('documentor')) {
                    this.ribbon = 'Documentor';
                } else if (this.route.includes('postman-collection')) {
                    this.ribbon = 'Postman Collection to API';
                } else if (this.route.includes('collections')) {
                    this.ribbon = 'API Collection';
                } else if (this.route.includes('dmn')) {
                    this.ribbon = 'Decision Builder';
                } else if (this.route.includes('uxbuilder')) {
                    this.ribbon = 'UX Builder';
                } else if (this.route.includes('coboltoapi')) {
                    this.ribbon = 'Cobol to API';
                } else if (this.route.includes('providers')) {
                    this.ribbon = 'Service Providers';
                } else if (this.route.includes('provider-category')) {
                    this.ribbon = 'Service Provider Category';
                } else if (this.route.includes('databases')) {
                    this.ribbon = 'Databases';
                } else if (this.route.includes('credits')) {
                    this.ribbon = 'Credits';
                } else if (this.route.includes('coupon-management')) {
                    this.ribbon = 'Coupon Management';
                } else if (this.route.includes('businessdetails')) {
                    this.ribbon = 'Business Details';
                } else if (this.route.includes('accounts')) {
                    this.ribbon = 'Accounts';
                } else if (this.route.includes('permissiongroup')) {
                    this.ribbon = 'Permission Group';
                } else if (this.route.includes('/businesslocations')) {
                    this.ribbon = 'Business Locations';
                } else if (this.route.includes('branding')) {
                    this.ribbon = 'Branding';
                } else if (this.route.includes('environments')) {
                    this.ribbon = 'Environments';
                } else if (this.route.includes('secrets-manager')) {
                    this.ribbon = 'Secrets Manager';
                } else if (this.route.includes('datacatalog')) {
                    this.ribbon = 'Data Catalog';
                } else if (this.route.includes('testsuite')) {
                    this.ribbon = 'Test Suite';
                } else if (this.route.includes('assign-roles')) {
                    this.ribbon = 'Assign Roles';
                } else if (this.route.includes('journey')) {
                    this.ribbon = 'Journey Analytics';
                } else if (this.route.includes('discover')) {
                    this.ribbon = 'Search';
                } else if (this.route.includes('docs')) {
                    this.ribbon = 'Developer Reference';
                } else if (this.route.includes('plsql')) {
                    this.ribbon = 'PL/SQL Builder';
                } else if (this.route.includes('accelerators')) {
                    this.ribbon = 'Accelerators';
                } else if (this.route.includes('data-transform-plans')) {
                    this.ribbon = 'Data Transformation Plans';
                } else if (this.route.includes('data-transform-history')) {
                    this.ribbon = 'Data Transformation History';
                } else if (this.route.includes('transform')) {
                    this.ribbon = 'Data Transformation';
                } else {
                    if (!this.route.includes('administration')) {
                        this.ribbon = 'Smart Control Plane';
                    }
                }

                if (this.route.includes('/products') || this.route.includes('/manage') || this.route.includes('/pricing') || this.route.includes('/about-us') || this.route.includes('/terms-of-service') || this.route.includes('/privacy-policy') ||
                    this.route.includes('/contact-us') || this.route.includes('/auth') || this.route.includes('/create') || this.route.includes('/integrate') || this.route.includes('/resources') || this.route.includes('/demo') || this.route.includes('/careers') || this.route.includes('?li_fat_id')) {
                    this.homeCheck = true;
                    this.SidePanelCheck = false;
                    this.subMenuPanelExpanded = false;
                } else {
                    this.homeCheck = false;
                    if (this.route.includes('/login') || this.route.includes('/signup') || this.route.includes('/verifyuser')
                        || this.route.includes('/home') || this.route.includes('/joinsrequest')
                        || this.route.includes('/plans') || this.route.includes('/resetpassword')
                        || this.route.includes('/legal') || this.route.includes('/Privacy-Policy')) {
                        this.SidePanelCheck = false;
                        this.subMenuPanelExpanded = false;
                    } else {
                        this.SidePanelCheck = true;
                    }
                }

            } else {
                //  this.homeCheck = true;
                // this.route = 'Home';
            }
        });

    }

    getEmail() {
        return localStorage.getItem('signInEmail');
    }

    addSvgIcons(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
        iconRegistry
            .addSvgIcon(
                'menu',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/menu.svg')
            )
            .addSvgIcon(
                'linkedin',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/linkedin.svg')
            )

            .addSvgIcon(
                'calendar',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/calendar.svg')
            )
            .addSvgIcon(
                'location',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/location.svg')
            )
            .addSvgIcon(
                'tick',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/tick.svg')
            )
            .addSvgIcon(
                'hexagon',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/hexagon.svg')
            )
            .addSvgIcon(
                'benifit-1',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/benifit-1.svg')
            )
            .addSvgIcon(
                'benifit-2',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/benifit-2.svg')
            )
            .addSvgIcon(
                'benifit-3',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/benifit-3.svg')
            )
            .addSvgIcon(
                'benifit-4',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/benifit-4.svg')
            )
            .addSvgIcon(
                'mail',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/mail.svg')
            )
            .addSvgIcon(
                'phone',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/phone.svg')
            )
            .addSvgIcon(
                'twitter',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/twitter.svg')
            )
            .addSvgIcon(
                'youtube',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/youtube.svg')
            )
            .addSvgIcon(
                'google',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/google.svg')
            )
            .addSvgIcon(
                'aws',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/aws.svg')
            )
            .addSvgIcon(
                'github',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/github.svg')
            )
            .addSvgIcon(
                'medium',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/medium.svg')
            )
            .addSvgIcon(
                'question',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/question.svg')
            )
            .addSvgIcon(
                'gitter',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/gitter.svg')
            )
            .addSvgIcon(
                'credit',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/credit.svg')
            )
            .addSvgIcon(
                'check',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/check.svg')
            )
            .addSvgIcon(
                'checked',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/checked.svg')
            )
            .addSvgIcon(
                'cross',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/cross.svg')
            )
            .addSvgIcon(
                'plus',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/plus.svg')
            )
            .addSvgIcon(
                'arrow',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/arrow.svg')
            )
            .addSvgIcon(
                'trial',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/trial.svg')
            )
            .addSvgIcon(
                'devex',
                sanitizer.bypassSecurityTrustResourceUrl('assets/svg/devex.svg')
            );
    }
}

@Component({
    selector: 'idle-watch',
    templateUrl: 'idle-watch.component.html',
    styleUrls: ['idle-watch.component.css']
})
export class IdleWatchComponent implements OnInit {

    incr: any;
    progressMessage: any;
    progress = 0;
    idleTimeout = 900;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<IdleWatchComponent>,
                public confPost: ConfService,
                public appComp: AppComponent,
                private authService: AuthService) {
        dialogRef.disableClose = true;

        if (this.data.idleTimeout) {
            this.idleTimeout = this.data.idleTimeout;
        }
    }

    ngOnInit() {

    }

    close() {
        this.dialogRef.close();
    }

    stay() {
        this.dialogRef.close();
        this.appComp.reset();
    }

    logoutOnIdle() {
        this.dialogRef.close();
        this.authService.logout();
    }

    getTimeOutTime() {
        const minutes = Math.floor(this.idleTimeout / 60);
        if (minutes > 0) {
            return minutes + ' minute' + (minutes === 1 ? '' : 's');
        } else {
            return this.idleTimeout % 60 + ' seconds';
        }
    }
}
